<template>
  <div class="specifictradelaw section">
    <div class="columns">
      <div class="column is-three-fifths-desktop is-offset-one-fifth-desktop">
        <h1 class="subtitle">特定商取引法に基づく表記</h1>
        <p class="block">特定商取引法に基づく表記が入ります。特定商取引法に基づく表記が入ります。特定商取引法に基づく表記が入ります。特定商取引法に基づく表記が入ります。</p>
        <p class="block">特定商取引法に基づく表記が入ります。特定商取引法に基づく表記が入ります。特定商取引法に基づく表記が入ります。特定商取引法に基づく表記が入ります。特定商取引法に基づく表記が入ります。</p>
        <div class="content">
          <ul>
            <li>リストリスト</li>
            <li>リストリスト</li>
            <li>リストリスト</li>
          </ul>
          <ol>
            <li>番号付きリストリスト</li>
            <li>番号付きリストリスト</li>
            <li>番号付きリストリスト</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpecificTradeLaw'
};
</script>

<style lang="scss" scoped>
  @import '../assets/scss/specific-trade-law.scss';
</style>
